import { useEffect, useState } from 'react';
import { fetchDocumentWordCount } from '../utils/document-word-count';

export function useDocumentWordCount(
  documentId: string | undefined,
  token: string | null,
  masterKey: string | null
): number | null {
  const [wordCount, setWordCount] = useState<number | null>(null);

  useEffect(() => {
    if (!documentId || (!token && !masterKey)) {
      setWordCount(null);
      return;
    }
    let cancelled = false;
    setWordCount(null);
    fetchDocumentWordCount(documentId, token, masterKey)
      .then((count) => {
        if (!cancelled) setWordCount(count);
      })
      .catch(() => {
        if (!cancelled) setWordCount(0);
      });
    return () => {
      cancelled = true;
    };
  }, [documentId, token, masterKey]);

  return wordCount;
}
